<app-select
  *ngIf="marketingSites"
  [control]="sitesCtrl"
  [items]="marketingSites"
  [multiple]="true"
  [localStorageKey]="siteKey"
  [optionTemplateName]="'site-icon'"
  [labelKey]="'account'">
</app-select>

<mat-tab-group
  mat-align-tabs="start"
  (selectedIndexChange)="updateDataSource($event)"
  [selectedIndex]="massMessagingService.tabIndex">
  <mat-tab>
    <ng-template matTabLabel>
      <span translate="mass_messaging/tab/to-send"></span>
      <span class="tab-counter">{{ campaignToSendSet.size | truncateCounter }}</span>
    </ng-template>
    <ng-template matTabContent>
      <ng-container *ngTemplateOutlet="massMessagingList; context: { displayedColumns: displayedColumnsForSend }">
      </ng-container>
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template matTabLabel>
      <span translate="mass_messaging/tab/scheduled"></span>
      <span class="tab-counter">{{ campaignToScheduledSet.size | truncateCounter }}</span>
    </ng-template>
    <ng-template matTabContent>
      <ng-container *ngTemplateOutlet="massMessagingList; context: { displayedColumns: displayedColumnsForScheduled }">
      </ng-container>
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template matTabLabel>
      <span translate="mass_messaging/tab/completed"></span>
    </ng-template>
    <ng-template matTabContent>
      <app-campaigns-completed
        [dataSourceBS]="dataSourceBS"
        [maxHeight]="maxHeight"
        [config]="config"></app-campaigns-completed>
    </ng-template>
  </mat-tab>
</mat-tab-group>

<ng-template #massMessagingList let-displayedColumns="displayedColumns">
  <div class="table-wrapper" [style.height.px]="maxHeight">
    <table
      #table
      mat-table
      [dataSource]="dataSource"
      matSort
      matSortActive="updateTime"
      matSortDirection="desc"
      (matSortChange)="sortData($event)">
      <ng-container matColumnDef="account">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="account"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <app-site-icon-and-name [item]="element.tmpFields?.account">{{
            element.tmpFields?.account.siteName
          }}</app-site-icon-and-name>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="common/name"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span>
            <ng-container *ngIf="element.is_test">
              <span class="testing-badge">
                {{ 'mass_messaging/testing-flag' | translate }}
              </span>
              &nbsp;
            </ng-container>
            {{ element.name }}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="numberOfMessagesSuccessfullySent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="mass_messaging/number_of_messages_successfully_sent"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <strong>{{ element.numberOfMessagesSuccessfullySent }}</strong>
        </td>
      </ng-container>
      <ng-container matColumnDef="numberOfMessagesNotSent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="mass_messaging/number_of_messages_not_sent"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <strong>{{ element.numberOfMessagesNotSent }}</strong>
        </td>
      </ng-container>
      <ng-container matColumnDef="numberOfErrors">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="mass_messaging/number_of_messages_in_error"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <app-errors-placeholder-cell
            [config]="config"
            [errors]="element.numberOfErrors"
            [id]="element.id"></app-errors-placeholder-cell>
        </td>
      </ng-container>
      <ng-container matColumnDef="remainingNumberOfMessagesToSend">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="mass_messaging/remaining_number_of_messages_to_send"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <strong>{{ element.remainingNumberOfMessagesToSend }}</strong>
        </td>
      </ng-container>
      <ng-container matColumnDef="read">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="mass_messaging/number_of_read"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <strong>{{ element.read }}</strong>
        </td>
      </ng-container>
      <ng-container matColumnDef="startTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="mass_messaging/start_time"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element.startTime | dateTimezone: 'short' }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="creatorEmail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="parameters/scenarios/creator"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element.creatorEmail }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="updateTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="parameters/scenarios/last_modification_date"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element.updateTime | dateTimezone: 'short' }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="scheduledTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="parameters/scenarios/scheduled_date"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element.scheduledTime | dateTimezone: 'short' }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="mass_messaging/status"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="massMessagingService.getStatusLabel(element) as label">
            <mat-chip-list>
              <mat-chip
                [ngClass]="MassMessagingStatusEnum[element.status]"
                [selected]="element.status !== MassMessagingStatusEnum.COMPLETED_STATUS">
                {{ label }}</mat-chip
              >
            </mat-chip-list>
          </ng-container>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span translate="actions"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="actions">
            <button mat-icon-button color="primary" type="button" (click)="openMassMessaging(element)">
              <mat-icon>visibility</mat-icon>
            </button>
            <button
              mat-icon-button
              color="primary"
              *ngIf="showEditButton(element)"
              type="button"
              (click)="editMassMessaging(element)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" type="button" (click)="deleteMassMessaging(element)">
              <mat-icon>delete</mat-icon>
            </button>
            <button
              class="action-btn"
              mat-raised-button
              color="primary"
              *ngIf="showActionButton(element)"
              type="button"
              [disabled]="element.disableActionButton"
              (click)="doActionOnMassMessaging(element)">
              {{ getActionButtonLabel(element) }}
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr [class.hidden]="row.hide" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</ng-template>
